// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var DOM__Search$SmartcutsMacros = require("../../devProtocol/DOM__Search.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../../../bs-utils/src/PromiseUtils.bs.js");
var QueryInBackground$SmartcutsMacros = require("../../QueryInBackground.bs.js");
var Selector__Background$SmartcutsMacros = require("../../Selector__Background.bs.js");

function nthParentInForeground(_n, _element) {
  while(true) {
    var element = _element;
    var n = _n;
    if (n === 0) {
      return Promise.resolve(Caml_option.some(element));
    }
    var parentElement = element.parentElement;
    if (parentElement == null) {
      return Promise.resolve(undefined);
    }
    _element = parentElement;
    _n = n - 1 | 0;
    continue ;
  };
}

function waitForElementInForegroundWithMatchingLabel(labelSelector, sharedRootDepth, includeElementsNotVisible, selector) {
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, true, undefined, undefined, includeElementsNotVisible, labelSelector).then(function (result_labelElement) {
                if (result_labelElement.TAG === /* Ok */0) {
                  return nthParentInForeground(List.length(labelSelector) - sharedRootDepth | 0, result_labelElement._0).then(function (maybeSharedRoot) {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: maybeSharedRoot
                                        });
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_labelElement._0
                            });
                }
              }).then(function (result_maybeSharedRoot) {
              if (result_maybeSharedRoot.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_maybeSharedRoot._0
                          });
              }
              var sharedRoot = OptionUtils$SmartcutsMacros.getExn("Expected Some(sharedRoot) when waitForElementInForegroundViaSearch()", result_maybeSharedRoot._0);
              var arg = Belt_List.drop(selector, sharedRootDepth);
              var selectorRelativeToSharedRoot = (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                  })("Expected Some(selector) after drop sharedRootDepth");
              return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, {
                          TAG: /* Element */0,
                          _0: sharedRoot,
                          _1: sharedRootDepth
                        }, false, undefined, undefined, undefined, selectorRelativeToSharedRoot);
            });
}

function waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, labelSelector, sharedRootDepth, includeElementsNotVisibleOpt, selector) {
  var includeElementsNotVisible = includeElementsNotVisibleOpt !== undefined ? includeElementsNotVisibleOpt : false;
  return Util$SmartcutsMacros.waitForPromise2(timeout, interval, (function (addOnPredicateTimedOutCallback) {
                  return PromiseUtils$SmartcutsMacros.resolveWith((function (param) {
                                  return OptionUtils$SmartcutsMacros.getExn("Expect Some(domTree) when waitForElementInBackgroundWithMatchingLabel()", param);
                                }), Selector__Background$SmartcutsMacros.fetchDomTree({
                                    tabId: tabId
                                  }, (function (param) {
                                      
                                    }))).then(function (domTree) {
                              return Curry.app(QueryInBackground$SmartcutsMacros.search1, [
                                            true,
                                            undefined,
                                            {
                                              tabId: tabId
                                            },
                                            /* Document */0,
                                            labelSelector,
                                            addOnPredicateTimedOutCallback,
                                            Caml_option.some(domTree),
                                            undefined,
                                            includeElementsNotVisible,
                                            undefined
                                          ]).then(function (result_maybeLabelElement) {
                                          if (result_maybeLabelElement.TAG !== /* Ok */0) {
                                            return Promise.resolve({
                                                        TAG: /* ErrorDuringPredicate */2,
                                                        _0: result_maybeLabelElement._0
                                                      });
                                          }
                                          var labelElement = result_maybeLabelElement._0;
                                          if (labelElement === undefined) {
                                            return Promise.resolve(/* PredicateNotSatisfied */0);
                                          }
                                          var maybeSharedRoot = Selector__Background$SmartcutsMacros.getNthParent(domTree, List.length(labelSelector) - sharedRootDepth | 0, labelElement);
                                          var sharedRoot = OptionUtils$SmartcutsMacros.getExn("Expected Some(sharedRoot) when waitForElementInBackgroundWithMatchingLabel()", maybeSharedRoot);
                                          var arg = Belt_List.drop(selector, sharedRootDepth);
                                          var selectorRelativeToSharedRoot = (function (param) {
                                                return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                              })("Expected Some(selector) after drop sharedRootDepth");
                                          return Curry.app(QueryInBackground$SmartcutsMacros.search1, [
                                                        false,
                                                        undefined,
                                                        {
                                                          tabId: tabId
                                                        },
                                                        {
                                                          TAG: /* Element */0,
                                                          _0: sharedRoot,
                                                          _1: sharedRootDepth
                                                        },
                                                        selectorRelativeToSharedRoot,
                                                        addOnPredicateTimedOutCallback,
                                                        Caml_option.some(domTree),
                                                        undefined,
                                                        includeElementsNotVisible,
                                                        undefined
                                                      ]).then(function (result_maybeNodeIdAndBackendNodeId) {
                                                      if (result_maybeNodeIdAndBackendNodeId.TAG !== /* Ok */0) {
                                                        return Promise.resolve({
                                                                    TAG: /* ErrorDuringPredicate */2,
                                                                    _0: result_maybeNodeIdAndBackendNodeId._0
                                                                  });
                                                      }
                                                      var nodeIdAndBackendNodeId = result_maybeNodeIdAndBackendNodeId._0;
                                                      if (nodeIdAndBackendNodeId !== undefined) {
                                                        return Promise.resolve({
                                                                    TAG: /* PredicateSatisfied */0,
                                                                    _0: nodeIdAndBackendNodeId
                                                                  });
                                                      } else {
                                                        return Promise.resolve(/* PredicateNotSatisfied */0);
                                                      }
                                                    });
                                        });
                            });
                })).then(function (result) {
              if (result.TAG === /* Ok */0) {
                var nodeIdAndBackendNodeId = result._0;
                switch (nodeIdAndBackendNodeId.TAG | 0) {
                  case /* PredicateDidResolveTo */0 :
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: nodeIdAndBackendNodeId._0
                                });
                  case /* TimedOut */1 :
                  case /* PredicateTimedOut */2 :
                      break;
                  
                }
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* SearchElementTimedOut */7,
                              _0: {
                                selector: selector,
                                ms: nodeIdAndBackendNodeId._0
                              }
                            }
                          });
              }
              var jsPromiseError = result._0;
              if (jsPromiseError.TAG === /* UncaughtPredicateError */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* ErrorWhileSearchForElement */9,
                              _0: jsPromiseError._0
                            }
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: jsPromiseError._0
                          });
              }
            });
}

exports.waitForElementInForegroundWithMatchingLabel = waitForElementInForegroundWithMatchingLabel;
exports.waitForElementInBackgroundWithMatchingLabel = waitForElementInBackgroundWithMatchingLabel;
/* Util-SmartcutsMacros Not a pure module */
